<template>
  <div>
    No tenants available, please contact your administrator to request access to a tenant.
  </div>
</template>